import handler from './handler';
// import system from './child/system';
// import common from './child/common';
// import frontdesk from './child/frontdesk';
// import finance from './child/finance';
// import teaching from './child/teaching';
// import datacenter from './child/datacenter';
// import jiaowu from './child/jiaowu';
// import appstore from './child/appstore';
// import storecard from './child/store-card';

import cspcedu from './child/cs-pc-edu';
import cspccrm from './child/cs-pc-crm';
import cspcreport from './child/cs-pc-report';
import memberpc from './child/member-pc';
import otherpc from './child/other-pc';

export const api = {
  // ...system,
  // ...common,
  // ...frontdesk,
  // ...finance,
  // ...teaching,
  // ...datacenter,
  // ...jiaowu,
  // ...appstore,
  // ...otherpc,

  ...cspcedu,
  ...cspccrm,
  ...cspcreport,
  ...memberpc,
  ...otherpc,
};

export default {
  install(application) {
    Object.assign(application.config.globalProperties, { api });
    application.provide('api', api);
    handler(application);
  },
};
